/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectDailyTaskReportQueryResult } from '../../models/get-project-daily-task-report-query-result';

export interface ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Params {
  ReportId?: string;
}

export function apiProjectDailyTaskReportsGetProjectDailyTaskReportGet(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsGetProjectDailyTaskReportGet.PATH, 'get');
  if (params) {
    rb.query('ReportId', params.ReportId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectDailyTaskReportQueryResult>;
    })
  );
}

apiProjectDailyTaskReportsGetProjectDailyTaskReportGet.PATH = '/api/ProjectDailyTaskReports/GetProjectDailyTaskReport';
